var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm:grid grid-cols-3 gap-12"},[_c('v-text-field',{attrs:{"name":"name","label":"Product","id":"id"}}),_c('v-text-field',{attrs:{"name":"name","label":"State","id":"id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }